import $ from 'jquery';
import 'jquery.easing';
import 'jquery.scrollto/jquery.scrollTo.min';

export default (element, callback = () => {}) => {
  event.preventDefault();
  const offset = window.innerWidth > 1040 ? 200 : 100;
  $(window).animate(
    {
      scrollTop: $(element).offset().top - offset
    },
    600,
    'swing'
  );
};
